import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TyreTracksIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.5 6.54V9.24L15.34 7.52V4.82L19.5 6.54ZM10.06 7.38L13.94 5.08V7.86L10.06 10.16V7.38ZM8.66 7.6V10.3L4.5 8.58V5.88L8.66 7.6ZM19.5 10.94V13.64L15.34 11.92V9.22L19.5 10.94ZM10.06 11.74L13.94 9.44V12.22L10.06 14.52V11.74ZM8.66 12V14.7L4.5 12.98V10.28L8.66 12ZM19.5 15.34V18.04L15.34 16.32V13.62L19.5 15.34ZM10.06 16.1L13.94 13.8V16.58L10.06 18.88V16.1ZM8.66 16.4V19.1L4.5 17.38V14.68L8.66 16.4Z" />
    </SvgIcon>
  );
});
